import React from 'react'
import PropTypes from 'prop-types'
import StepperType from './StepperType'

class StepGo extends React.Component {
  static displayName = 'StepGo'

  static propTypes = {
    previous: PropTypes.string,
    next: PropTypes.string,
    switchStepName: PropTypes.string,
    stepper: StepperType,
    passedProps: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.validateProps()
  }

  validateProps() {
    // eslint-disable-next-line react/prop-types
    const { previous, next, children } = this.props
    if (!previous && !next) {
      throw new Error('previous or next attribute is required')
    }
    if (children) {
      throw new Error('Child element not supported in StepGo')
    }
  }

  componentDidMount() {
    const { stepper } = this.props
    const { previous, next, switchStepName, ...passedProps } = this.props
    if (previous) {
      stepper.goToPreviousStep(previous, switchStepName, passedProps)
    } else if (next) {
      stepper.goToNextStep(next, switchStepName, passedProps)
    }
  }

  render() {
    return null
  }
}

export default StepGo
